export const meKey = {
  all: ["me"] as const,
  me: () => [...meKey.all] as const,
  buldingTree: () => [...meKey.all, "buildingTree"] as const,
};
